import Chart from "react-apexcharts";
import dayjs from "dayjs";
const prepareChartData = (data) => {
  return data.map((set) => {
     if (set.type === "scatter") {
       if (set.date.length === 0) {
        const correspondingSet = data.find(
          (item) => item.type === "line" && item.date.length === set.data.length
        );

        if (correspondingSet) {
          return {
            name: set.name,
            type: set.type,
            data: correspondingSet.date.map((date, index) => ({
              x: dayjs(date).format("YYYY-MM-DD HH:mm"),
              y: set.data[index],
            })),
          };
        }
      } else {
         return {
          name: set.name,
          type: set.type,
          data: set?.date?.length ? set?.date.map((date, index) => ({
            x: dayjs(date).format("YYYY-MM-DD HH:mm"),
            y: set.data[index],
          })):[],
        };
      }
    }

     return {
      name: set.name,
      type: set.type,
      data: set?.date?.length ? set?.date.map((date, index) => ({
        x: dayjs(date).format("YYYY-MM-DD HH:mm"),
        y: set.data[index],
      })):[],
    };
  });
};

const ScatterLine = ({chartUtils}) => {
  
 
 
  const formattedData = prepareChartData(chartUtils?.series);
   // Chart options
  const options = {
    chart: {
      height: 400,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    stroke: {
       curve: "smooth",
    },
    markers: {
      size: [5, 5, 5,5, 5, 5],
      shape: "circle",
    },
    xaxis: {
      type: "datetime",
      title: {
        text: "Date & Time",
      },
    },
    yaxis: [
      {
        title: {
          text: "Small Range Values",
        },
        
      },
      {
        title: {
          text: "testben - Set 3 Values",
        }, 
        opposite: true,
      },
    ],
    tooltip: {
      x: {
        format: "yyyy-MM-dd HH:mm",
      },
      shared: true,
      intersect: false,
    },
    legend: {
      position: "top",
      horizontalAlign: "center",
    },
  };
  return (
    <div className="chart-container">
      <Chart
        options={options}
        series={formattedData}
        type="line"
        height={400}
      />
    </div>
  );
};

export default ScatterLine;
